import { twMerge } from 'tailwind-merge';

import RewardDistributionHistorySection from '../RewardDistributionHistorySection/RewardDistributionHistorySection';

type TableHeaderRowProps = {
  title: string;
  variant?: 'default' | 'referral' | 'rewardDistributionHistory' | 'rewardDistributionHistoryLight';
  width?: string;
};

export const TableHeaderRow = ({ title, variant = 'default', width }: TableHeaderRowProps) => {
  const variantStyles = {
    default: {
      text: 'tw-text-menuLinkColor',
      font: 'tw-font-semibold tw-text-[16px] tw-text-center',
    },
    referral: {
      text: 'tw-text-white',
      font: 'tw-font-jost tw-text-[12px]',
    },
    rewardDistributionHistory: {
      text: 'tw-text-white',
      font: 'tw-font-jost tw-text-[12px] lg:tw-text-[20px] tw-font-bold',
    },
    rewardDistributionHistoryLight: {
      text: 'tw-text-menuLinkColor',
      font: 'tw-font-jost tw-text-[12px] lg:tw-text-[20px] tw-font-bold',
    },
  } as const;

  return (
    <div
      className={twMerge(
        'tw-font-semibold',
        width || 'tw-flex-1',
        variantStyles[variant].text,
        variantStyles[variant].font
      )}
    >
      {title}
    </div>
  );
};
